import { useSuspenseQuery } from "@tanstack/react-query"
import { trpc } from "app/trpc"

export const useCurrentYear = () => {
  const { data: currentYear } = useSuspenseQuery({
    ...trpc.schooljaren.getCurrentYear.queryOptions(),
    refetchOnReconnect: false,
  })

  return currentYear
}
